/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var qty_bundle_cls = ".th_pb_qty_bundle_cls" 
var observer = new MutationObserver(function(mutations){
  for (var i=0; i < mutations.length; i++){
    for (var j=0; j < mutations[i].addedNodes.length; j++){
      if (mutations[i].addedNodes[j].matches(qty_bundle_cls)){
        const offer = document.getElementsByClassName('special-offer')[0];
        offer.style.display = 'inline-block';
        observer.disconnect();
      };
    }
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});